import {Button} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {FC, useRef, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {transformFilterExpressionDtoToExpressionArray} from 'features/predicate-expression-form-list';

import {IPostRiskDocumentsArgs, TRuleProp} from '../../api/types';
import {IEditRiskDocumentsFormProps, TRisksDocumentsFormRef} from '../../model/types';
import {RisksDocumentsService} from '../../services';
import {RisksDocumentsForm} from './risks-documents-form';


export const EditRisksDocumentsForm: FC<IEditRiskDocumentsFormProps> = ({value, fields, fetchData}: IEditRiskDocumentsFormProps) => {
    const [form] = useForm();
    const riskDocumentsFormRef = useRef<TRisksDocumentsFormRef>(null);
    const hasLoadedRef = useRef(false);
    const [rule, setRule] = useState<TRuleProp>(null);
    const [isEmpty, setIsEmpty] = useState<boolean>(false);

    const onFinish = async (values: IPostRiskDocumentsArgs) => {
        try {
            await RisksDocumentsService.post(values);
            await fetchData();
        } catch (e) {
            console.error('Ошибка обновления/создания записи: ', e);
        }
    };

    return (
        <ModalOpenerComponent
            component={<Button type="link">{value}</Button>}
            controlsStyle={{marginTop: '20px'}}
            modalProps={{title: 'Настройка правила связи', width: 1600}}
            controlLabels={{save: 'Сохранить'}}
            disabledControls={{save: isEmpty}}
            onShow={async () => {
                if (hasLoadedRef.current) return;
                hasLoadedRef.current = true;
                try {
                    const {data} = await RisksDocumentsService.getRuleByRiskId(fields.id);

                    setRule(transformFilterExpressionDtoToExpressionArray(data));
                } catch (e) {
                    console.error('Ошибка получения записей: ', e);
                }
            }}
            afterModalClose={() => {
                hasLoadedRef.current = false;
                form.resetFields();
            }}
            handleSave={async (setIsModalOpen) => {
                try {
                    await form.validateFields();
                    const isValid = await riskDocumentsFormRef.current?.validate();
                    if (isValid) {
                        form.submit();
                        setIsModalOpen(false);
                    }
                } catch (e) {
                    console.error(e);
                }
            }}
            shouldConfirm={() => form.isFieldsTouched() || !!riskDocumentsFormRef.current?.isRulesDirty()}
            handleCancel={(setIsModalOpen) => {
                form.resetFields();
                setIsModalOpen(false);
            }}
        >
            <RisksDocumentsForm
                ref={riskDocumentsFormRef}
                fields={fields}
                formInstance={form}
                onFinish={onFinish}
                setIsEmpty={setIsEmpty}
                rule={rule}
                isEdit
            />
        </ModalOpenerComponent>
    );
};
